import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const BuildUpDescription: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <>
      <Block>
        <p>Welcome to YUNG&apos;s <b>Build Up</b> program.</p>
        <p>This 30 day program is focused on helping individuals develop the internal
          and external resources they need for deeper psychological work in the
          next stage, Drill Down.
        </p>

        <h1 className="mt-16">What Should I Expect?</h1>
        <p>Our program relies on three pillars: <b>diagnostics, personalization</b>,
          and <b>psychotherapy</b>.
        </p>
        <p>Therefore, each YUNG session consists of:</p>
        <ul className="list-rhombus">
          <li>Core Practice - a guided therapeutic audio assembled by YUNG’s AI
            specifically for you
          </li>
          <li>Articles + exercises that expand on your Core Practice for improved
            results
          </li>
          <li>A series of quick diagnostic questions to help us get to know you</li>
        </ul>
      </Block>

      <Block>
        <p>Each session takes 20 to 30 minutes.</p>
        <p>
          At any time, you can chat with a YUNG Psychologist about your guided session to discuss
          insights, ask questions, or just have a conversation and get support.
        </p>
      </Block>

      <Block>
        <h1 className="mt-16">Program Outcomes</h1>
        <p>Through this program, participants will learn how to identify and access the resources
          they need to support their mental health, and will be equipped
          with <b>powerful techniques for self-healing and self-compassion</b>.
        </p>

        <p>By the end of the program, participants can expect to see several positive changes
          in their everyday lives, such as:
        </p>
        <ul className="list-rhombus">
          <li>improved mood and emotional well-being,</li>
          <li>increased ability to handle stress and difficult emotions,</li>
          <li>greater self-awareness and self-acceptance,</li>
          <li>more effective communication and interpersonal skills.</li>
        </ul>

        <p>
          Additionally, participants will
          gain <b>a stronger sense of purpose and directionin life</b>,
          as well as a deeper understanding of their own needs and how to meet them. The tools and
          skills gained through this program will support their mental health and well-being on
          an ongoing basis, allowing them to live a happier and more fulfilling life.
        </p>
      </Block>

      <Block>
        <h1 className="mt-16">What’s Next?</h1>
        <p>
          After completing Build Up, participants will be ready to move on to the next stage
          of YUNG&apos;s program - Drill Down. This stage focuses on addressing deep psychological
          issues and developing new and useful skills and solutions to help individuals overcome
          their challenges and improve their overall well-being. Our AI will be trained to support
          participants&apos; specific needs and will recommend highly-effective programs based on
          their results from Build Up.
        </p>
      </Block>
    </>
  )
}
